module.exports = __webpack_public_path__ + "7d0f4e3f5e4040e43f230c01475a1edc.svg";


//////////////////
// WEBPACK FOOTER
// ./images/archive-icon-copy-blue.svg
// module id = 65
// module chunks = 0